import { useMutation, useQueryClient } from 'react-query';
import {
  addBuddyPreference,
  type AddBuddyPreferenceBody,
  type AddBuddyPreferenceResponse
} from '../../../findBuddy/services/findBuddyService';

export function useAddBuddyPreference() {
  const queryClient = useQueryClient();
  return useMutation<AddBuddyPreferenceResponse, Error, AddBuddyPreferenceBody>(
    (body: AddBuddyPreferenceBody) => addBuddyPreference(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['myBuddyPreferences']);
      }
    }
  );
}
